// extracted by mini-css-extract-plugin
export default {"infoBox":"ContactInfo-module--infoBox--bOnLT","infoBox__item":"ContactInfo-module--infoBox__item--V5YAS","infoBox__item__dark":"ContactInfo-module--infoBox__item__dark--OdosW"};